import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { InputLabel, Stack, Tooltip } from '@mui/material';
import { DesktopDateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { Control, Controller } from 'react-hook-form';
import { getBrowser12HourTime } from 'v2/utils/dateTime';
import { UserFormValues } from './userFormValues';

interface Props {
  control: Control<UserFormValues>;
}

const ExpirationDateField = ({ control }: Props) => {
  const { translation } = useTranslation();
  const minExpirationDate = dayjs().add(1, 'minute');

  return (
    <Stack gap={0.5}>
      <InputLabel sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
        {translation.expiration_from_group}
        <Tooltip title={translation.expiration_from_group_tooltip}>
          <InfoOutlined fontSize="small" />
        </Tooltip>
      </InputLabel>
      <Controller
        name="expirationDate"
        control={control}
        rules={{
          validate: (value) =>
            !value || (value.isValid() && !value.isBefore(minExpirationDate)) || translation.expiration_date_past_error
        }}
        render={({ field, fieldState }) => (
          <DesktopDateTimePicker
            label={`${translation.expiration_date} (${translation.optional.toLowerCase()})`}
            ampm={getBrowser12HourTime()}
            value={field.value}
            views={['year', 'day', 'hours', 'minutes']}
            minDateTime={minExpirationDate}
            onChange={field.onChange}
            slotProps={{
              field: { clearable: true },
              textField: {
                id: 'expiration-date-picker',
                error: !!fieldState.error,
                helperText: fieldState.error?.message
              }
            }}
          />
        )}
      />
    </Stack>
  );
};

export default ExpirationDateField;
